// https://mui.com/material-ui/react-snackbar/
import Snackbar from '@mui/material/Snackbar';
//import Alert from '@mui/material/Alert';

import { lazy } from "react";

// dynamic import to avoid warning on npm run build because it is used dynamically on other places
const Alert = lazy(() => import('@mui/material/Alert'));

export default function Toast({open,setOpen,message,error}) {

	const handleClose = () => {
    	setOpen(false);
    };

	return (
		<>
		{
			(
				(message && message.length > 0) ||
				(error && error.length > 0)
			)
			&&
	        <Snackbar
	            anchorOrigin={{ vertical: 'top', horizontal : 'center'}}
	            open={open}
	            onClose={handleClose}
	            key='top center'
	            autoHideDuration={3000}
	            className='max-sm:px-1'
	            sx={{ 
	            	whiteSpace: 'pre-line', 
	            	marginTop: 7
	            }}
	        >	        	
	        	<Alert
				    onClose={handleClose}
				    severity={message && message.length > 0 ? "success" : "error"}
				    variant="filled"
				    sx={{ 
				    	width: '100%'				    	
				    }}
				  >
			    	{
			    		message && message.length > 0 ? 
			    			message 
			    		:
			    			error && error.length > 0 ? 
			    				error
			    			:
			    				''
			    	}
			  	</Alert>			  	
			</Snackbar>
		}
		</>
	)
}